import axios from 'axios';

export const getCerts = () =>
  axios.get(`/api/member-certification/me`);

  export const getCertsByGuid = (guid) =>
  axios.get(`/api/member-certification/guid/${guid}`);

  

export const removeCert = id =>
  axios.delete(`/api/member-certification/${id}`);

  export const removeCertByGUID = (id,guid) =>
  axios.delete(`/api/member-certification/${id}/guid/${guid}`);

export const uploadCert = (file) => {
  let formData = new FormData();
  formData.append("files", file);
  return axios.post(
    `/api/member-certification/uploadWithoutCheckingName`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );
};

export const uploadWithConditional = (file, data) => {
  let formData = new FormData();
  formData.append("files", file);
  formData.append("cmd", JSON.stringify(data))
  return axios.post(
    `/api/member-certification/uploadWithConditional`,
      formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );
};


export const uploadCertWithoutDuplicationChecking = (file) => {
  let formData = new FormData();
  formData.append("files", file);
  return axios.post(
    `/api/member-certification/uploadWithoutCheckingNameAndDuplication`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );
};

export const uploadCertHKID = (data) => 
  axios.post(`/api/member-certification/upload/hkidAndName`,data);

export const uploadCertHKIDWithoutName = (data) => 
  axios.post(`/api/member-certification/upload/hkidWithoutName`,data);

  export const uploadCertWithoutNameAndHKID = (data) => 
  axios.post(`/api/member-certification/upload/WithoutNameAndHkid`,data);
    
  export const checkIsCertSign = (certId,dummyFileId) => 
  axios.post(`/api/member-certification/checkIsCertSign?certID=${certId}&dummyFileID=${dummyFileId}`);
   


  export const autoLogoutDummyAccount = () => 
  axios.post(`/api/user/logout`);

  export const getOrCreateDummyFolder = () => 
  axios.get(`/ess/api/dummyFolder`);

  
  export const forgetCertification = (data) => 
  axios.post(`/api/member-registration/forgetCertification`,data);
  
  export const getRegistrationPublicSystemSetting = () => 
    axios.get(`/api/systemsetting/module/0905151F-95D2-4C33-8443-09F44DF05A0E/public`).then(res => res.data);

  export const forgetPassword = (username,email) => 
    axios.post(`/api/member-registration/forgetPassword`,{LoginName:username,Email:email});
    

    export const getEdriveUrl = () => 
    axios.get(`/ess/api/system-setting/getEDriveLoginUrl`);
    